import { buildNumerologyReport } from '../numerology/analysisBuilder';
import { PROFILE_KINDS } from './types';

/**
 * Extension point: today only numerology contributes. Later, merge Human Design
 * theme records and synthesis without replacing numerology modules.
 *
 * @param {object} input - passed to numerology (may include sampleMode, profileKind)
 * @param {object} [options]
 * @param {string} [options.profileKind] - PROFILE_KINDS.*
 */
export function buildSymbolicProfileReport(input, options = {}) {
  const profileKind = input.profileKind || options.profileKind || PROFILE_KINDS.NUMEROLOGY_ONLY;

  const numerologyResult = buildNumerologyReport(
    { ...input, profileKind },
    { ...options, profileKind },
  );

  if (!numerologyResult.ok) {
    return numerologyResult;
  }

  return {
    ...numerologyResult,
    profileKind,
    contributions: {
      numerology: {
        bundle: numerologyResult.bundle,
        weighted: numerologyResult.weighted,
        theme: numerologyResult.theme,
        themeRecords: numerologyResult.themeRecords,
        report: numerologyResult.report,
      },
      humanDesign: null,
    },
    /** Future: pass merged theme rows + cross-system copy into voice layer */
    extensionHooks: {
      mergeThemeRecords: null,
      mergeSynthesisSection: null,
      attachHumanDesign: null,
    },
  };
}
